import { Injectable, inject } from "@angular/core";
import { interval, map, retry, switchMap } from "rxjs";

import { WalletRepo } from "@app/core/wallet/domain/repository/wallet.repo";
import { WalletCommunication } from "@app/core/wallet/domain/wallet.comunication";

@Injectable({ providedIn: "root" })
export class InitWalletSubscriptionUseCase {
  private static readonly DEFAULT_INTERVAL_MILISECONDS = 60000;

  private readonly walletRepo = inject(WalletRepo);
  private readonly walletCommunication = inject(WalletCommunication);

  execute(): void {
    this.findWallet().subscribe();

    interval(InitWalletSubscriptionUseCase.DEFAULT_INTERVAL_MILISECONDS)
      .pipe(
        switchMap(() => this.findWallet()),
        retry(InitWalletSubscriptionUseCase.DEFAULT_INTERVAL_MILISECONDS)
      )
      .subscribe();
  }

  private findWallet() {
    return this.walletRepo
      .find()
      .pipe(map((wallet) => this.walletCommunication.write(wallet)));
  }
}
